import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';



const slides = [
  {
    img: 'Battlefield-6-03-1024x576.jpg',
    alt: 'Gaming banner',
  },
  {
    img: 'BO7_LOGO_NEGATIVE_BLACK-BACKGROUND-1024x576.jpg',
    alt: 'Ouest France Banner',
  },
  {
    img: 'gta-6.jpg',
    alt: 'Third slide',
  },
   {
    img: 'EA-FC-26-1024x576.jpg',
    alt: 'Third slide',
  },
     {
    img: 'Metal-Gear-Solid-Delta-Key-Art-1024x576.jpg',
    alt: 'Third slide',
  },
 
];

export default function Slider() {
  return (
    <div style={{ maxWidth: '100%', margin: 'auto', borderRadius: 16, overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        navigation={true}
        style={{ '--swiper-pagination-color': '#4b00cc', '--swiper-navigation-color': '#4b00cc' }}
      >
        {slides.map(({ img, alt }, idx) => (
          <SwiperSlide key={idx}>
            <img
              src={img}
              alt={alt}
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                borderRadius: '16px',
                userSelect: 'none',
                pointerEvents: 'none',
              }}
              draggable={false}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}